import React from "react";

import "./Styles.css";

const InputText = ({ type, name, id, disabled = false, value, label, containerStyle = "container-text", styleInput = "input-text", styleLabel = "label-text", error = false, msgError, ...props}) => {

    const removeError = (element) => {
        let target = element.target
        target.classList.remove("error")
    }

    return (
        <div className={[containerStyle]}>
            { label ? <label className={styleLabel}>{label}</label> : null }
            <input name={name} type={type} disabled={disabled} id={id} className={[styleInput]} value={value} {...props} onChange={removeError} />
            {!error ? null :
                <div className="msgError">
                    <small>{msgError}</small>
                </div>
            }
        </div>
    )
}

export default InputText